import { useCallback, useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import { messageAlertError } from 'commons/error'
import {
  COMMENTS_ENTITY_TYPE,
  COMMENTS_CREATOR_TYPE,
} from 'app/constants/messageDetail'

import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  // update Reply
  SET_IS_UPDATING_REPLY: 'SET_IS_UPDATING_REPLY',
  SET_IS_UPDATE_REPLY_FAIL: 'SET_IS_UPDATE_REPLY_FAIL',
  SET_IS_UPDATE_REPLY_SUCCESS: 'SET_IS_UPDATE_REPLY_SUCCESS',
  // delete Reply
  SET_IS_DELETE_REPLY_SUCCESS: 'SET_IS_DELETE_REPLY_SUCCESS',
  RESET: 'RESET',
}

const initialState = {
  // update Reply
  isUpdatingReply: false,
  isUpdateReplySuccess: false,
  // delete Reply
  isDeleteReplySuccess: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_IS_UPDATING_REPLY:
      return {
        ...state,
        isUpdatingReply: action.value,
      }
    case ActionType.SET_IS_UPDATE_REPLY_SUCCESS:
      return {
        ...state,
        isUpdatingReply: false,
        isUpdateReplySuccess: true,
      }
    case ActionType.SET_IS_UPDATE_REPLY_FAIL:
      return {
        ...state,
        isUpdatingReply: false,
        isUpdateReplySuccess: false,
      }
    case ActionType.SET_IS_DELETE_REPLY_SUCCESS:
      return {
        ...state,
        isDeleteReplySuccess: action.value,
      }
    case ActionType.RESET:
      return initialState
    default:
      return state
  }
}

export default function useReplyBox(
  notiId,
  replyId,
  createId,
  onFetchCommentList = () => {},
) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const handleAlertError = useCallback(
    (error) => {
      return commonDispatch(
        MessageAlert.showError({
          message: messageAlertError(error, formatMessage),
        }),
      )
    },
    [commonDispatch, formatMessage],
  )

  const onUpdateReply = async (value) => {
    dispatch({
      type: 'SET_IS_UPDATING_REPLY',
      value: true,
    })
    effects.apis
      .updateComment(
        notiId,
        {
          ...value,
          entityType: COMMENTS_ENTITY_TYPE,
          entityId: notiId,
          parentId: replyId,
          creatorType: COMMENTS_CREATOR_TYPE,
          creatorId: createId,
        },
        replyId,
      )
      .then(async () => {
        dispatch({
          type: 'SET_IS_UPDATE_REPLY_SUCCESS',
        })
        onFetchCommentList()
      })
      .catch((error) => {
        handleAlertError(error)
        dispatch({
          type: 'SET_IS_UPDATE_REPLY_FAIL',
        })
      })
  }

  const onDeleteReply = async () => {
    await effects.apis
      .deleteComment(notiId, replyId)
      .then(async () => {
        dispatch({
          type: 'SET_IS_DELETE_REPLY_SUCCESS',
          value: true,
        })
        commonDispatch(
          MessageAlert.showSuccess({
            message: formatMessage({
              id: 'draft.notification.delete.success.message',
            }),
          }),
        )
        onFetchCommentList()
      })
      .catch((error) => {
        dispatch({
          type: 'SET_IS_DELETE_REPLY_SUCCESS',
          value: false,
        })
        handleAlertError(error)
      })
  }

  const reset = () => {
    dispatch({
      type: 'RESET',
    })
  }

  return {
    state,
    reset,
    onDeleteReply,
    onUpdateReply,
  }
}
